import React from 'react';
import './progressMeter.scss';
import "@fontsource/open-sauce-one";

//const dividerColorChange = [5,15,25,35,46,56,66,76,87,97]
const dividerColorChange = [10,23,35,46,58,70,82,93]

function ProgressMeter(props) {
  const { width, mileStoneData,data,isQualified, height } = props;
  // console.log("width",width)
  let progressBarMargin = isQualified?{"margin-bottom": "0px"}:{}
  return (
    <div className="progressBarContainer" style={progressBarMargin}>
      <div className="progressBarContainer__ProgressBar" style={{height: height + "em"}}>
        <span
          className="progressBarContainer__ProgressBar__Indicator"
          style={{ width: `${width}%` }}
        >
          <span className="progressBarContainer__ProgressBar__Indicator--Fill"></span>
        </span>
       {/* { !isQualified&&<><div className="progressBarContainer__qualifierBar"/>
      <img src={QualifierFlagIcon} className="progressBarContainer__qualifierIcon"/></>} */}
      </div>
      {/* <div className="progressBarContainer__progressBarDividersContainer"> */}
        {/* <><div className="progressBarContainer__progressBarDividersContainer__completion">
          {data?.completedPercent}
        </div>
          <div className="progressBarContainer__progressBarDividersContainer__goal">
            Goal:{' '} {data?.goal}
          </div></> */}
        {<div className="progressBarContainer__progressBarDividersContainer__row">
          {mileStoneData?.map((milestone, index) => <ProgressBarDividers key={index} index={index} amount={milestone?.text} bgColor={milestone?.bgColor} textColor={milestone?.textColor} width={width} />)}
        </div>}
      {/* </div> */}
    </div>
  );
}

const ProgressBarDividers = ({ index, amount, bgColor, textColor, width=0 }) => {
  return (
    <div className="progressBarDividers" style={{ marginTop: index % 2 !== 0 ? "19.5px" : "-18px" }}>
      {index % 2 === 0 && <div className="progressBarDividers__priceEmblem progressBarDividers__priceEmblem--top" style={{
        background: bgColor,
        color: textColor,
        "--databgColor": bgColor,
        marginBottom:"11px",
      }}>{amount}</div>}
      <div className="progressBarDividers__progressBarDividerLines"
      style={{background:width>=dividerColorChange[index]?"#FFFFFF":"rgba(255, 255, 255, 0.2)"}}></div>
      {index % 2 !== 0 && <div className="progressBarDividers__priceEmblem progressBarDividers__priceEmblem--bottom" style={{
        background: bgColor,
        color: textColor,
        "--databgColor": bgColor,
        marginTop: "15px",
      }}>{amount}</div>}
    </div >
  )
}

export default ProgressMeter;
